<body>
  <div class="grid-overlay">
    <app-page-header></app-page-header>

    <div class="form-container">
      <h1>{{ 'onboardingUserUpdate.title' | translate }}</h1>

      <form [formGroup]="userForm" (ngSubmit)="save()">
        <div class="form-grid">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserUpdate.fields.name.label' | translate }}</mat-label>
            <input matInput formControlName="name_user" required>
            @if (userForm.get('name_user')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserUpdate.fields.name.requiredError' | translate }}
              </mat-error>
            }
            @if (userForm.get('name_user')?.hasError('minlength')) {
              <mat-error>
                {{ 'onboardingUserUpdate.fields.name.minLengthError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserUpdate.fields.lastName.label' | translate }}</mat-label>
            <input matInput formControlName="lastName_user" required>
            @if (userForm.get('lastName_user')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserUpdate.fields.lastName.requiredError' | translate }}
              </mat-error>
            }
            @if (userForm.get('lastName_user')?.hasError('minlength')) {
              <mat-error>
                {{ 'onboardingUserUpdate.fields.lastName.minLengthError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserUpdate.fields.email.label' | translate }}</mat-label>
            <input matInput type="email" formControlName="email_user" required>
            @if (userForm.get('email_user')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserUpdate.fields.email.requiredError' | translate }}
              </mat-error>
            }
            @if (userForm.get('email_user')?.hasError('email')) {
              <mat-error>
                {{ 'onboardingUserUpdate.fields.email.emailError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'onboardingUserUpdate.fields.status.label' | translate }}</mat-label>
            <mat-select formControlName="status_user" required>
              @for (status of statusOptions; track status) {
                <mat-option [value]="status.value">
                  {{ status.label }}
                </mat-option>
              }
            </mat-select>
            @if (userForm.get('status_user')?.hasError('required')) {
              <mat-error>
                {{ 'onboardingUserUpdate.fields.status.requiredError' | translate }}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="roleId">
              <mat-option value="">Sin rol</mat-option>
              @for (role of roles; track role) {
                <mat-option [value]="role.id">
                  {{ role.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-actions">
          <button type="button" mat-raised-button (click)="goBack()" class="cancel-btn">
            {{ 'onboardingUserUpdate.buttons.cancel' | translate }}
          </button>
          <button type="submit" mat-raised-button color="primary" [disabled]="userForm.invalid">
            {{ 'onboardingUserUpdate.buttons.save' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</body>
